<template>
  <div>
    <ul class="evaluate-icons">
      <li v-for="(item, idx) in iconsList" :key="idx" class="evaluate-icon">
        <img
          v-if="ques.appearance"
          class="icon"
          :src="
            require(`../assets/evaluate${ques.appearance}${
              idx <= level - 1 ? '_s' : ''
            }@2x.png`)
          "
          alt=""
          @click="level = idx + 1"
        />
      </li>
    </ul>
    <p class="selected-state" v-if="level !== -1">{{ levelName }}</p>
    <ul class="selected-title" v-if="level !== -1 && listTitles.length">
      <li
        v-for="(item, idx) in listTitles"
        :key="idx"
        :class="{ 'tag-selected': answer.evaluateLabels.includes(item) }"
        @click="handleClick(item)"
      >
        {{ item }}
      </li>
    </ul>
    <el-input
      class="textMultiple1"
      v-if="ques.openUserEvaluate && level !== -1"
      type="textarea"
      :rows="2"
      placeholder="请填写您的宝贵意见"
      v-model="answer.userEvaluation"
      maxlength="40"
      answerize="none"
      @change="handleInput"
    ></el-input>
  </div>
</template>
<script>
export default {
  data() {
    return {
      level: -1,
      iconsList: new Array(5),
      answer: {
        appearance: '', // 外观
        levelName: '', // 打分级别名称
        level: -1, // 打分数
        evaluateLabels: [], // 标签数组
        openUserEvaluate: false, // 用户填答是否开启
        userEvaluation: '' // 用户填答内容
      }
    }
  },
  props: ['ques'],
  computed: {
    listTitles() {
      // 根据打分显示相应的标签
      if (this.level === -1) {
        return []
      }
      let labels = this.ques.evaluateLabels[this.level - 1].labels
      labels = labels.replace(/;/g, '；')
      const list = labels.split('；')
      if (labels && list.length) {
        return list.filter((item) => item !== '')
      }
      return []
    },
    levelName() {
      if (this.level === -1) {
        return ''
      }
      return this.ques.evaluateLabels[this.level - 1].levelName
    }
  },
  watch: {
    level: {
      // 打分处理事件
      handler(val) {
        this.answer.level = val
        this.answer.evaluateLabels = []
        this.answer.appearance = this.ques.appearance
        this.answer.levelName = this.ques.evaluateLabels[val - 1].levelName
        this.answer.openUserEvaluate = this.ques.openUserEvaluate
        this.ques.isFinish = true
      }
    },
    ques: {
      immediate: true,
      handler() {
        this.$set(this.ques, 'answer', this.answer)
      }
    }
  },
  methods: {
    handleClick(item) {
      const idx = this.answer.evaluateLabels.indexOf(item)
      if (idx !== -1) {
        this.answer.evaluateLabels.splice(idx, 1)
      } else {
        this.answer.evaluateLabels.push(item)
      }
      this.ques.isFinish = true
    },
    handleInput(val) {
      this.ques.answer.userEvaluation = val
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluate-icons {
  min-height: 50px;
  .evaluate-icon {
    float: left;
    margin-right: 5px;
    img {
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
  }
}
.textMultiple1 /deep/.el-textarea__inner {
  appearance: none;
  -webkit-appearance: none;
}
.selected-state {
  color: #ff552d;
  font-size: 14px;
  margin-bottom: 10px;
}
.selected-title {
  display: block;
  min-height: 50px;
  li {
    border: 1px solid #ddd;
    float: left;
    background: #ffffff;
    border-radius: 2px;
    height: 30px;
    line-height: 30px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    padding: 0 15px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    &.tag-selected {
      border: 1px solid #ff552d;
      color: #ff552d;
    }
  }
}
@media screen and (max-width: 468px) {
  .option-text {
    font-size: 0.7rem;
  }
  .sorted-box {
    font-size: 0.7rem;
  }
  .default-box {
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    transform: scale(1);
  }
  .evaluate-icons {
    display: flex;
    justify-content: space-between;
  }
  .selected-state {
    text-align: center;
  }
  .selected-title {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/evaluate.vue